export default function description() {
    return (
        <div className="card__description-basic">
            <div className="card__description">
                <p className="card__description-title">
                    Загальна характеристика
                </p>
                <p className="card__description-text">
                    АРКОНА СУМО (NS VLSP) — це високопродуктивний гібрид соняшнику з одним із найвищих потенціалів урожайності у своїй групі. Гібрид поєднує інтенсивний тип розвитку з підвищеною стійкістю до хвороб, що робить його універсальним рішенням для сучасних господарств.
                </p>
                <p className="card__description-text">
                    Завдяки технології SUMO®, АРКОНА забезпечує ефективний контроль бур’янів та стабільну реалізацію потенціалу навіть за високого гербіцидного навантаження.
                </p>
                <p className="card__description-title">Основні переваги</p>
                <ol className="card__description-list">
                    <li className="card__description-numbering">Дуже високий потенціал урожайності — до 6,0 т/га</li>
                    <li className="card__description-numbering">Високопродуктивний гібрид інтенсивного типу</li>
                    <li className="card__description-numbering">Висока стійкість до основних хвороб</li>
                    <li className="card__description-numbering">Стійкість до вовчка — 5 рас (A–E)</li>
                    <li className="card__description-numbering">Стійкість до всіх рас несправжньої борошнистої роси</li>
                    <li className="card__description-numbering">Відмінна адаптивність до різних умов вирощування</li>
                </ol>
                <table className="card__description__table">
                    <tr>
                        <td className="card__description__td">Період вегетації</td>
                        <td className="card__description__th-index">104–107 днів</td>
                    </tr>
                    <tr>
                        <td className="card__description__td">Олійність:</td>
                        <td className="card__description__th-index">51–53%</td>
                    </tr>
                    <tr>
                        <td className="card__description__td card__description__td--link">Висота рослин</td>
                        <td className="card__description__th-index">160–170 см</td>
                    </tr>
                </table>
                <p className="card__description-title">
                    Рекомендації по густоті
                </p>
                <ol className="card__description-list">
                    <li className="card__description-numbering">За достатнього зволоження: 60–70 тис. рослин/га</li>
                    <li className="card__description-numbering">У посушливих умовах: 45–50 тис. рослин/га</li>
                </ol>
                <div className="card__description-title">Стійкість та толерантність</div>
                <ol className="card__description-list">
                    <p className="card__description-text">
                        Стійкість:
                    </p>
                    <li className="card__description-numbering">Вилягання, осипання, холодостійкість — 9/10</li>
                    <li className="card__description-numbering">Посухостійкість — 8/10</li>
                    <p className="card__description-text">
                        Толерантність до хвороб:
                    </p>
                    <li className="card__description-numbering">Пероноспороз, фомоз, вугільна гниль, іржа, фомопсис — 9/10</li>
                    <li className="card__description-numbering">Альтернаріоз, септоріоз, біла та сіра гнилі — 8/10</li>
                </ol>
                <div className="card__description-title">Рекомендовані зони вирощування</div>
                <p className="card__description-text">
                    Гібрид рекомендований для вирощування в усіх агрокліматичних зонах України, з найкращою реалізацією потенціалу у Лісостепу та Степу.
                </p>
                <div className="card__description-title">Рекомендації щодо вирощування</div>
                <p className="card__description-text">
                    АРКОНА СУМО — це гібрид інтенсивного типу, який максимально розкриває свій потенціал за високого агрофону. Рекомендується застосування гербіцидів системи SUMO® (Експрес + ПАР Тренд) для ефективного контролю бур’янів. Гібрид добре реагує на удобрення та сучасні технології захисту.
                </p>
                <p className="card__description-text">
                   АРКОНА СУМО — це вибір для тих, хто хоче максимальний урожай і преміальну якість. Ідеально підходить для інтенсивних господарств, які працюють на результат і прибуток з кожного гектара.
                </p>
            </div>
            <div className="card__description-preference">
                <div className="aside__title--new">Головні переваги</div>
                <div className="asede__head">
                    <div className="aside__block">Високий потенція урожайності</div>
                    <div className="aside__block">Найкращу віддачу забезпечує на родючих грунтах</div>
                    <div className="aside__block">Один із найбільш високоврожайних гібридів з високим вмістом олії</div>
                </div>
            </div>
        </div>
    );
}
